import { z } from "zod";
import { ANALYTICS_PRESETS } from "./analytics-range.js";

export const ANALYTICS_REPORT_FORMATS = ["csv"] as const;

export type AnalyticsReportFormat = (typeof ANALYTICS_REPORT_FORMATS)[number];

export const analyticsReportQuerySchema = z
	.object({
		format: z.enum(ANALYTICS_REPORT_FORMATS),
		preset: z.enum(ANALYTICS_PRESETS).optional(),
		from: z.iso.datetime().optional(),
		to: z.iso.datetime().optional(),
	})
	.refine((value) => value.preset !== undefined || (value.from !== undefined && value.to !== undefined), {
		message: "Either preset or both from and to must be provided",
	});

export type AnalyticsReportQuery = z.infer<typeof analyticsReportQuerySchema>;
